export function mapRowToChunkIndex(rowIndex: number, limit: number) {
    // Возвращает индекс чанка, в котором находится строка с индексом rowIndex
    return Math.ceil((rowIndex + 1) / limit) - 1;
}
